import * as React from 'react';
import './EditForm.css';
import StaticForm from '../StaticForm/StaticForm';
import Form from 'react-jsonschema-form';
export default function EditForm(_ref) {
  var formData = _ref.formData,
    editSchema = _ref.editSchema,
    editUISchema = _ref.editUISchema,
    editTransformErrors = _ref.editTransformErrors,
    editArrayFieldTemplate = _ref.editArrayFieldTemplate,
    editValidate = _ref.editValidate,
    onChange = _ref.onChange,
    onError = _ref.onError,
    onSubmit = _ref.onSubmit,
    size = _ref.size,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "bluebox__edit-box auto-bluebox-edit-box"
  }, /*#__PURE__*/React.createElement(StaticForm, {
    formData: formData,
    schema: editSchema,
    uiSchema: editUISchema,
    transformErrors: editTransformErrors,
    ArrayFieldTemplate: editArrayFieldTemplate,
    validate: editValidate,
    onChange: onChange,
    onSubmit: onSubmit,
    onError: onError,
    component: Form,
    size: size
  }, children));
}